import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Steps, Tooltip, Spin, message, Table, Popconfirm } from 'components/shared/AntComponent';
import { Form, Radio, Select, Input, InputNumber, Button, DatePicker, TextArea, TimePicker } from 'components/shared/FormComponent';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { createExam, getExamDetail } from 'services/store/actions/examAction';
import { getQuestionTemplate } from 'services/store/actions/questionPaperAction';
import { getAccountDetail } from 'services/store/actions/accountAction';
import { DeleteFilled, LoadingOutlined } from '@ant-design/icons';
import AddSlotScreen from 'components/exam/sub-screens/AddSlotScreen';
import CreateSlot from './CreateSlot';
import { getCourse, getPublicCourse } from 'services/store/actions/masterDataAction';

const CreateExam: React.FC = () => {
    const location = useLocation();
    const history = useNavigate();
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { loading21, courseInfo, loading12: specLoading, specialisationInfo, pubCourseInfo, loading30 } = useSelector((state: any) => state.master);
    const { loading: loadingQuestions, loading11, templateInfo, paperInfo, loading4: paperLoading } = useSelector((state: any) => state.questionpaper);
    const { success1, loading1, error1, examDetailInfo, loading4, deptQuesInfo, loading12, loading15: autoLoading, autoQuesInfo, loading16, newAutoQuesInfo,
        loading13, success13, error13, addexamData
    } = useSelector((state: any) => state.exam);
    const { invAccountInfo, loading3 } = useSelector((state: any) => state.account);
    const [currentStep, setCurrentStep] = useState(0);
    const [isPastDate, setIsPastDate] = useState(false);
    const [isRetakeExam, setIsRetakeExam] = useState(false);
    const [duration, setDuration] = useState(0);
    const [slots, setSlots]: any = useState([]);
    const [rowData, setRowData]: any = useState(null);
    const [tempOpt, setTempOpt]: any = useState([]);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success1 : false;
    const [showErrmsg, setShowErrMsg] = useState(false);
    const errormsg = showErrmsg ? error1 : false;
    const [savedFormData, setSavedFormData] = useState<any>(null);
    const EXAM_SAVED_FLAG = 'examSaved';
const [formLoading, setFormLoading] = useState(true);
    const tenantId = Number(localStorage.getItem('tenantID'));

const collegeLabel = tenantId === 1153 ? "Batch" : "College";
useEffect(() => {
    const examId = location?.state?.id;

    if (examId === 0) {
        resetCreateExam();
        setFormLoading(false);
    } 
    else if (examId) {
        setFormLoading(true); // 👈 add this
        getDetail(examId);
    }
}, [location?.state?.id]);

useEffect(() => {
    if (location?.state?.id && location.state.id !== 0 && examDetailInfo?.data) {
        loadData1();
        setFormLoading(false); // 👈 add this
    }
}, [examDetailInfo?.data]);

    const stepItems: any = [
        { key: 1, status: "process", icon: 1, title: "Create Exam", content: "" },
        {
            key: 2, status: "wait", icon: 2, title: "Update Slots", content: ""
        },
        // { key: 3, status: "wait", icon: 3, title: "Complete" }
    ];

    const goToPreviousScreen = () => {
        history('/exam');
    };

    const templateOptions = !loading11 && templateInfo?.data?.map((item: any) => {
        return {
            value: item?.quesTemplateID,
            label: item?.quesTemplateName
        }
    }) || [];

    const accOptions: any = !loading3 && invAccountInfo?.data?.map((acc: any) => {
        return {
            label: acc?.accountName,
            value: acc.id?.toString(),
            key: acc.id,
        };
    }) || [];
    const deptOptions = useMemo(() =>
        !loading30 && pubCourseInfo?.data?.map((item: any) => ({
            label: item?.courseName,
            value: item?.masCourseID,
            actualID: 0
        })) || [],
        [loading21, pubCourseInfo]
    );

    const courseOptions = useMemo(() =>
        !loading21 && courseInfo?.data?.map((item: any) => ({
            label: item?.courseName,
            value: item?.masCourseID,
            actualID: 0,
        })) || [],
        [loading21, courseInfo]
    );

    const specOptions = useMemo(() =>
        !specLoading && specialisationInfo?.data?.map((item: any) => ({
            value: item?.specializationId,
            label: item?.specializationName,
            id: item?.specializationId,
            description: item.description,
            actualID: 0
        })) || [],
        [specLoading, specialisationInfo]
    );


    function getTemplates() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getQuestionTemplate(id) as any);
    }

    useEffect(() => {
        getTemplates();
    }, []);

    function getAccountInfo() {
        const id = 0 + "/" + Number(localStorage.getItem('tenantID'));
        dispatch(getAccountDetail(id) as any);
    }

    useEffect(() => {
        getAccountInfo();
    }, []);

    const disablePastDates = (current: dayjs.Dayjs) => {
        // Disable dates before today
        return current && current < dayjs().startOf('day');
    };
  
    const handleRetakeChange = (e: any) => {
        setIsRetakeExam(e.target.value);
    }

    const handleDurationChange = (e: any) => {
        setDuration(e);
        if (slots && slots.length > 0) {
            const updatedSlots = slots.map((slot: any) => {
                const startTime = dayjs(slot?.slotStartTime?.format('HH:mm a'), 'HH:mm a');
                if (!startTime?.isValid()) {
                    return slot; // Return the slot as is if the start time is invalid
                }

                const endTime = startTime.add(e, 'minute'); // e is the duration in minutes

                return {
                    ...slot,
                    slotEndTime: endTime, // Update the end time in HH:mm a format
                };
            });
        }
    }
    function getCourseList() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getCourse(id) as any);
    }

    function getPublicCourseList() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getPublicCourse(id) as any);
    }

    useEffect(() => {
        getCourseList();
        getPublicCourseList();
        // getSpecialisationDetails();
    }, []);


    const submitForm = async () => {
        try {
            const val = await form.validateFields();
            // Save form data before moving to next step
            setSavedFormData(val);

            const options = [];
            const slots = val?.slots || [];
            if (slots?.length > 0) {
                for (let i = 0; i < slots?.length; i++) {
                    options.push({
                        ExamSlotId: slots[i]?.slotID || 0,
                        ExamID: 0,
                        ExamSlotName: slots[i]?.slotName || "",
                        ExamStartTime: dayjs(slots[i]?.startTime).format('HH:mm:ss'),
                        ExamEndTime: dayjs(slots[i]?.endTime).format('HH:mm:ss'),
                        ExamDuration: val?.duration?.toString() || "",
                        ConditionIDs: slots[i]?.specialization?.toString(),
                        IsAssoCondition: slots[i]?.associateCondition || "",
                        ConditionName: slots[i]?.conditionName?.toString() || "",
                        TotalCapacity: slots[i]?.capacity,
                        "Status": slots[i]?.status || "active",
                        "AccountId": val?.college ? Number(val?.college) : 0,
                        "TenantId": Number(localStorage.getItem('tenantID')),
                        // "QuestionPaper": null
                    })
                }
            }
            const inputJson = {
                "ExamID": location?.state?.id || 0,
                "ExamName": val.examName || "",
                "ExamDescription": val.description || "",
                "QuesTemplateID": val.questionTemplate?.toString() || "",
                "QuesTemplateName": val.questionTemplate ? templateOptions?.filter((item: any) => val?.questionTemplate?.includes(item.value))
                    ?.map((o: any) => o.label)?.join(",") : "",
                "ExamDuration": val.duration?.toString(),
                "ExamDate": val?.examDate ? dayjs(val.examDate).format('YYYY-MM-DD') : '',
                "QuesGenMode": "Auto",
                "TotalMarks": val?.totalMark || 0,
                "NegativeMarks": val?.negativeMark || 0,
                "IsAutoSubmit": true,
                "IsAllowRetake": val?.retakeExam || false,
                "MaxAttempts": val?.maxAttempts ? Number(val?.maxAttempts) : 0,
                "IsShowResultAFExam": val?.showResult || true,
                "AccountName": val?.college ? accOptions?.find((item: any) => item.value === val?.college)?.label : "",
                "AccountId": val?.college ? Number(val?.college) : 0,
                "TenantId": Number(localStorage.getItem('tenantID')),
                "ExamSlots": options || null,
            };
            dispatch(createExam(inputJson) as any);
            setShowSuccessmsg(true);
            setShowErrMsg(true);
        }
        catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    };
    // Modified loadData - for new exam (id = 0 and flag is false)
const loadData = () => {
    form.setFieldsValue({
        examName: "",
        examDate: null,
        duration: null,
        college: null,
        totalMark: null,

        // 🔥 MUST be null
        negativeMark: null,
        automateQuestions: null,
        showResult: null,
        allowRetake: null,
        maxAttempts: null,

        questionTemplate: null,
        description: "",
        slots: [{
            slotID: 0,
            slotName: "",
            startTime: null,
            endTime: null,
            capacity: null,
            associateCondition: '',
            specialization: null,
            status: '',
        }]
    });
};

 
    const loadData1 = () => {
        if (examDetailInfo?.data?.length > 0) {
            const defaultValue = examDetailInfo?.data?.[0];
            setDuration(defaultValue?.examDuration);
            form.setFieldsValue({
                examName: defaultValue?.examName || "",
                examDate: defaultValue?.examDate ? dayjs(new Date(defaultValue?.examDate)) : null,
                duration: defaultValue?.examDuration ? Number(defaultValue?.examDuration) : null,
                college: defaultValue?.accountId?.toString() || null,
                totalMark: defaultValue?.totalMarks || null,
                negativeMark: defaultValue?.negativeMarks || 0,
                automateQuestions: true,
                showResult: defaultValue?.isShowResultAFExam || false,
                allowRetake: defaultValue?.isAllowRetake || false,
                maxAttempts: defaultValue?.maxAttempts || null,
                questionTemplate: defaultValue?.quesTemplateID ? defaultValue?.quesTemplateID?.split(',')?.map(Number) : null,
                description: defaultValue?.examDescription || "",
                slots: defaultValue?.examSlots?.map((item: any) =>
                ({
                    slotID: item.examSlotId || 0,
                    slotName: item.examSlotName || '',
                    startTime: item.examStartTime ? dayjs(item.examStartTime, 'HH:mm:ss') : null,
                    endTime: item.examEndTime ? dayjs(item.examEndTime, 'HH:mm:ss') : null,
                    associateCondition: item.isAssoCondition || "",
                    status: item.status || 'active',
                    capacity: item.totalCapacity || '',
                    specialization: item.isAssoCondition === "gender" ? item?.conditionIDs?.split(',') : item?.conditionIDs?.split(',')?.map(Number) || "",
                    conditionName: item.isAssoCondition === "gender" ? item?.conditionName?.split(',') : item?.conditionName?.split(',') || "",
                }))
            });
            const slotJson = defaultValue?.examSlots?.map((value: any) => ({
                ExamSlotId: value?.examSlotId || 0,
                ExamID: defaultValue?.examID || 0,
                ExamSlotName: value.examSlotName || "",
                ExamStartTime: value.examStartTime || null,
                ExamEndTime: value.examEndTime || null,
                ExamDuration: defaultValue?.examDuration || null,
                IsAssoCondition: value.isAssoCondition || "",
                ConditionIDs: value.isAssoCondition === "gender" ? value?.conditionIDs?.split(',') : value?.conditionIDs?.split(',')?.map(Number) || "",
                ConditionName: value.isAssoCondition === "gender" ? value?.conditionName?.split(',') : value?.conditionName?.split(',') || "",
                TotalCapacity: value.totalCapacity || "",
                Status: value.status || "active",
                TenantId: Number(localStorage.getItem('tenantID')),
                AccountId: Number(defaultValue?.accountId) || null,
                QuestionPaper: {
                    QuesPaperID: value?.questionPaper?.quesPaperID || 0,
                    QuesPaperName: value?.questionPaper?.quesPaperName || "",
                    QuesGenMode: "Auto",
                    ExamID: defaultValue?.examID || 0,
                    ExamName: defaultValue?.examName || "",
                    SlotID: value?.examSlotId || 0,
                    SlotName: value.examSlotName || "",
                    NoOfQuestions: defaultValue?.totalMarks,
                    TotalMarks: defaultValue?.totalMarks,
                    Notes: value?.questionPaper?.notes || "",
                    TenantId: Number(localStorage.getItem('tenantID')),
                    EasyPercent: value?.questionPaper?.easyPercent,
                    MediumPercent: value?.questionPaper?.mediumPercent,
                    HardPercent: value?.questionPaper?.hardPercent,
                    IsCombinedTemplate: true,
                    Status: "Active",
                    QpSections: value?.questionPaper?.qpSections?.map((item: any) => ({
                        QpSectionID: item?.qpSectionID || 0,
                        QuesPaperID: item?.quesPaperID || 0,
                        QpSectionName: item.qpSectionName || "",
                        IsAssoCondition: item.isAssoCondition || "",
                        ConditionName: item.conditionName?.toString() || "",
                        QuesTemplateID: item.quesTemplateID?.toString() || "",
                        QuesTemplateName: item.quesTemplateName || "",
                        TenantId: Number(localStorage.getItem('tenantID')),
                    })) || null
                }
            }))
            setSlots(slotJson);
        }
        // setIsLoaded(true);
    }

    const resetCreateExam = () => {
    form.resetFields();

    // 🔥 reset ALL related states
    setIsRetakeExam(false);
    setDuration(0);
    setSlots([]);
    setTempOpt([]);
    setRowData(null);
    setCurrentStep(0);
};


useEffect(() => {
    const examId = location?.state?.id;

    if (examId === 0) {
        // CREATE MODE
        resetCreateExam();

        form.setFieldsValue({
        negativeMark: null,
        automateQuestions: true,  
        showResult: false,         
        allowRetake: false,        
        maxAttempts: null,
    });
setIsRetakeExam(false);
    } else if (examId) {
        // EDIT MODE
        getDetail(examId);
    }
}, [location?.state?.id]);


useEffect(() => {
    if (location?.state?.id && location.state.id !== 0 && examDetailInfo?.data) {
        loadData1(); // fill form with API data
    }
}, [examDetailInfo?.data]);

useEffect(() => {
    if (location?.state?.id === 0) {
        setIsRetakeExam(false);
    }
}, [location?.state?.id]);


    useEffect(() => {
        if (successmsg) {
            if (location?.state?.id === 0) {
                message.success('Exam saved successfully');
                localStorage.setItem(EXAM_SAVED_FLAG, 'true');
                getDetail(addexamData?.data);
                localStorage.setItem('examID', addexamData?.data);
            } else {
                message.success('Exam updated successfully');
            }
            const temp = form.getFieldValue('questionTemplate');
            const opt = templateOptions?.filter((item: any) => temp?.includes(item.value))?.map((item: any) => ({
                value: item.value,
                label: item.label
            })) || [];
            setTempOpt(opt);
            setCurrentStep(1);
            setShowSuccessmsg(false);
        }
        if (errormsg) {
            if (errormsg?.message) {
                message?.error(errormsg?.message);
            } else {
                message.error("Exam couldn't be created");
            }
            setShowErrMsg(false);
        }
    }, [successmsg, errormsg]);

    const getDetail = (ids: any) => {
        const id = ids + "/" + Number(localStorage.getItem('tenantID'));
        dispatch(getExamDetail(id) as any);
    };

    useEffect(() => {
        const id=localStorage.getItem('examID')||null;
        if (location.state.id !== 0) {
            getDetail(location.state.id);
        }else if(id){
            getDetail(id);
        }
    }, [location.state.id]);

    const handleStartTimeChange = (time: any, index: number) => {
        if (time && duration) {
            const startTime = dayjs(time);
            const endTime = startTime.add(duration, 'minute');

            const currentSlots = form.getFieldValue('slots') || [];
            const updatedSlots = [...currentSlots];
            updatedSlots[index] = {
                ...updatedSlots[index],
                startTime: time,
                endTime: endTime
            };

            form.setFieldsValue({ slots: updatedSlots });
        }
    };
    const handleAssociateConditionChange = (value: any, index: any) => {
        const currentSlots = form.getFieldValue('slots') || [];
        const updatedSlots = [...currentSlots];

        // Clear specialization when changing associate condition
        updatedSlots[index] = {
            ...updatedSlots[index],
            associateCondition: value,
            specialization: null
        };

        // Also clear section departments
        if (updatedSlots[index]?.qpList?.section) {
            updatedSlots[index].qpList.section = updatedSlots[index].qpList.section.map((sec: any) => ({
                ...sec,
                department: null
            }));
        }

        form.setFieldsValue({ slots: updatedSlots });
        handleSlotFieldChange(index, 'associateCondition', value);
    };
    // Update sections when slot fields change
    const handleSlotFieldChange = (slotIndex: any, field: any, value: any) => {
        if (field === 'associateCondition' || field === 'specialization') {
            setTimeout(() => {
                updateSectionsForSlot(slotIndex);
            }, 100);
        }
    };

    const genderOptions = [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "other", label: "Other" }
    ];
    const updateSectionsForSlot = (slotIndex: any) => {
        const currentSlots = form.getFieldValue('slots') || [];
        const slot = currentSlots[slotIndex];

        if (!slot) return;

        const associateCondition = slot.associateCondition;
        const specializations = slot.specialization || [];
        const selectedTemplates = form.getFieldValue('questionTemplate') || [];

        let newSections = [];

        // If nothing is selected in associateCondition, keep default section
        if (!associateCondition) {
            newSections = [{
                qpSectionID: 0,
                qpSectionName: "",
                isAssoCondition: "all",
                conditionName: [],
                quesTemplateID: null,
            }];
        }
        // If specializations are selected, create sections based on them
        else if (specializations && specializations.length > 0) {
            newSections = specializations.map((spec: any, index: any) => {
                // Get the label for the specialization
                let specLabel = spec;
                if (associateCondition === 'dept') {
                    const courseOption = courseOptions?.find((opt: any) => opt.value === spec);
                    specLabel = courseOption?.label || spec;
                } else if (associateCondition === 'course') {
                    const specOption = specOptions?.find((opt: any) => opt.value === spec);
                    specLabel = specOption?.label || spec;
                } else if (associateCondition === 'gender') {
                    const genderOption = genderOptions?.find((opt: any) => opt.value === spec);
                    specLabel = genderOption?.label || spec;
                }

                return {
                    qpSectionID: 0,
                    qpSectionName: ``,
                    isAssoCondition: associateCondition,
                    conditionName: [spec],
                    quesTemplateID: selectedTemplates.length > index ? selectedTemplates[index] : selectedTemplates[0] || null,
                };
            });
        }
        // If associateCondition is selected but no specializations (shouldn't happen due to validation)
        else {
            newSections = [{
                qpSectionID: 0,
                qpSectionName: "All",
                isAssoCondition: associateCondition,
                conditionName: [],
                quesTemplateID: selectedTemplates.length > 0 ? selectedTemplates[0] : null,
            }];
        }

        // Update the qpList sections for this slot
        const updatedSlots = [...currentSlots];
        updatedSlots[slotIndex] = {
            ...updatedSlots[slotIndex],
            qpList: {
                ...updatedSlots[slotIndex].qpList,
                section: newSections
            }
        };

        form.setFieldsValue({ slots: updatedSlots });
    };
    const getSpecializationOptions = (condition: string) => {
        switch (condition) {
            case 'dept':
                return deptOptions || []; // Department specializations
            case 'course':
                return courseOptions || []; // Course options (B.E, B.Tech, etc.)
            case 'gender':
                return genderOptions; // Gender options
            case 'all':
                return [];
            default:
                return [];
        }
    };
    const getSpecializationOptions1 = (condition: string) => {
        switch (condition) {
            case 'dept':
                return courseOptions || []; // Department specializations
            case 'course':
                return specOptions || []; // Course options (B.E, B.Tech, etc.)
            case 'gender':
                return genderOptions; // Gender options
            case 'all':
                return conditionOptions1 || [];
            default:
                return [];
        }
    };
    const getSpecializationLabel = (condition: string) => {
        switch (condition) {
            case 'dept':
                return 'Department';
            case 'course':
                return 'Course';
            case 'gender':
                return 'Gender';
            case 'all':
                return 'All selected';
            default:
                return '';
        }
    };

    const statusOptions = [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" }
    ];


    const conditionOptions1 = [
        { value: "aptitude", label: "Aptitude" }
    ];
    const getFilteredTemplateOptions = (currentIndex: number) => {
        const selectedTemplates = form.getFieldValue('questionTemplate') || [];
        if (selectedTemplates.length === 0) {
            return templateOptions;
        }

        // Get the value selected in the current row
        const currentValue = selectedTemplates[currentIndex]?.templateID;
        // Get all selected template IDs from other rows
        const selectedInOtherRows = selectedTemplates
            .map((item: any, index: number) =>
                index !== currentIndex ? item?.templateID : null
            )
            .filter((id: any) => id !== null && id !== undefined);
        const filtered = templateOptions.filter((template: any) => {
            // Show if not selected in other rows OR if it's the current selection
            return !selectedInOtherRows.includes(template.value) || template.value === currentValue;
        });
        return filtered;
    };
    const options = [
        { label: "Department", value: "dept" },
        { label: "Course", value: "course" },
        { label: "Gender", value: "gender" }
    ];
    const options1 = [
        { label: "All", value: "all" },
        { label: "Department", value: "dept" },
        { label: "Course", value: "course" },
        { label: "Gender", value: "gender" }
    ];
    const getFilteredAssociateConditionOptions = () => {
        const usedConditions = slots
            ?.map((slot: any) => slot?.IsAssoCondition)
            .filter(Boolean) || [];

        const currentValue = rowData?.IsAssoCondition;

        return options.filter((opt) => {
            if (currentValue === opt.value) return true;
            return !usedConditions.includes(opt.value);
        });
    };

    // const handleFormChange = (val: any) => {
    //     if (val) {
    //         const sections = form.getFieldValue('sections') || [];
    //         const clearedSections = sections && sections.map((section: any) => ({
    //             ...section,
    //             assCondition: null,
    //             department: null,
    //         }));
    //         form.setFieldValue('sections', clearedSections);

    //         setSectionAssCondMap({});
    //         setSectionDeptMap({});
    //         setOptions2([]);
    //         setDisableAddSection(false);

    //         if (val === "dept") {
    //             setDependentOptions(deptOptions);
    //             const opt = [
    //                 { value: "all", label: "All" },
    //                 { value: "dept", label: "Department" }
    //             ];
    //             setOptions1(opt);
    //             form.setFieldValue("deptCourseGender", null);
    //             form.setFieldValue("ConditName", null);
    //         } else if (val === "course") {
    //             setDependentOptions(courseOptions);
    //             const opt = [
    //                 { value: "all", label: "All" },
    //                 { value: "course", label: "Course" }
    //             ];
    //             setOptions1(opt);
    //             form.setFieldValue("deptCourseGender", null);
    //             form.setFieldValue("ConditName", null);
    //         } else if (val === "gender") {
    //             setDependentOptions(genderOptions);
    //             const opt = [
    //                 { value: "all", label: "All" },
    //                 { value: "gender", label: "Gender" }
    //             ];
    //             setOptions1(opt);
    //             form.setFieldValue("deptCourseGender", null);
    //             form.setFieldValue("ConditName", null);
    //         }
    //     }
    // };
    return (
        <div className="my-3 children-container">
            <div className="px-0 ">
                <div className="row m-0 page-header">
                    <h5 className="my-auto col text-start ps-2 text-secondary fw-bold">{location?.state?.id === 0 ? 'Create Exam' : 'Update Exam'}</h5>
                    <div className="ms-auto col-md-8 text-end my-auto pe-2">
                        <Button type="primary" className="col-auto ms-2 btn-back" onClick={goToPreviousScreen}>
                            Back
                        </Button>
                    </div>
                </div>
            </div>
<Spin spinning={loading4 || loadingQuestions || formLoading}>
                <div className="body-content mx-0 mt-2 row px-2">
                    <Steps
                        type="navigation"
                        current={currentStep}
                        onChange={(e: any) => { setCurrentStep(e); }}
                        className="site-navigation-steps bg-white mb-3"
                        items={stepItems}
                    />
                    <div className="bg-white p-2 mb-2">
                        {currentStep == 0 ?
                            <Form form={form} layout="vertical" preserve={false} initialValues={{
    automateQuestions: true,  
    showResult: false,        
    allowRetake: false        
  }} className="bg-white p-2">
                                <div className='row mx-0 '>
                                    <div className="px-2 py-3 form-padding">
                                        <div className="d-flex m-0 flex-wrap">
                                            <Form.Item className="col-md-6 px-2" label="Exam Title" name="examName"
                                                normalize={(value) =>
                                                    value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
                                                }
                                                rules={[{ required: true, message: 'This field is required' }]}>
                                                <Input disabled={isPastDate} />
                                            </Form.Item>
                                            <Form.Item className="col-md-2 col-lg-2 px-2" label="Date of Exam" name="examDate" rules={[{ required: true, message: 'This field is required' }]}>
                                                <DatePicker className="w-100" format="DD-MM-YYYY" disabledDate={disablePastDates} disabled={isPastDate} />
                                            </Form.Item>
                                            <Form.Item className="col-md-2 col-lg-2 px-2" label="Duration (In Minutes)" name="duration" rules={[{ required: true, message: 'This field is required' }]}>
                                                <InputNumber className="w-100" maxLength={3} onChange={(e) => handleDurationChange(e)} disabled={isPastDate} />
                                            </Form.Item>
<Form.Item
    label={`Select ${collegeLabel}`}
    name="college"
    className="col-md-2 px-2"
    rules={[{ message: "This field is required", required: true }]}
>
                                                <Select options={accOptions}
                                                    filterOption={(input: any, option: any) => {
                                                        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                    }}
                                                    filterSort={(optionA, optionB) => (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
                                                    // onChange={handleAccountChange}
                                                    notFoundContent={
                                                        <div className="text-center p-4">
                                                            {loading3 ? (
                                                                <span>
                                                                    <LoadingOutlined />
                                                                    Loading...
                                                                </span>
                                                            ) : (
                                                                <span>No college found</span>
                                                            )}
                                                        </div>
                                                    } />
                                            </Form.Item>
                                        </div>
                                        <div className="row m-0">
                                            <Form.Item className="col-md-2 col-lg-2 px-2" label="Total Mark" name="totalMark" rules={[{ required: true, message: 'This field is required' }]}>
                                                <InputNumber className="w-100" maxLength={3} disabled={isPastDate} />
                                            </Form.Item>
                                            <Form.Item className="col-md-2 col-lg-2 px-2" label="Negative Mark" name="negativeMark" rules={[{ required: true, message: 'This field is required' }]}>
                                                <InputNumber className="w-100" maxLength={3} disabled={isPastDate} />
                                            </Form.Item>
                                            <Form.Item className="col-md-2 col-lg-2 px-2" label="Automate Questions" name="automateQuestions" rules={[{ required: true, message: 'This field is required' }]}>
                                                <Radio.Group className='ms-1' >
                                                    <Radio value={true} >Yes </Radio>
                                                    <Radio value={false} >No</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                            <Form.Item className="col-md-2 col-lg-2 px-2" label="Show results after submission" name="showResult" rules={[{ required: true, message: 'This field is required' }]}>
                                                <Radio.Group className='ms-1' disabled={isPastDate}>
                                                    <Radio value={true} >Yes </Radio>
                                                    <Radio value={false} >No</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                            <Form.Item className="col-md-2 col-lg-2 px-2" label="Allow retake exam" name="allowRetake" rules={[{ required: true, message: 'This field is required' }]}>
                                                <Radio.Group className='ms-1' onChange={(e) => handleRetakeChange(e)} disabled={isPastDate}>
                                                    <Radio value={true} >Yes </Radio>
                                                    <Radio value={false} >No</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                            {isRetakeExam ?
                                                <Form.Item className="col-md-2 col-lg-2 px-2" label="Max. Attempts" name="maxAttempts" rules={[{ required: true, message: 'This field is required' }]}>
                                                    <Input />
                                                </Form.Item> : ""}
                                        </div>
                                        <div className="row m-0">
                                            <Form.Item label="Select Question Paper Template" name="questionTemplate" className="col px-2" rules={[{ message: "This field is required", required: true }]}>
                                                <Select options={templateOptions} mode="multiple"
                                                    filterOption={(input: any, option: any) => {
                                                        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                    }}
                                                    filterSort={(optionA, optionB) => (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
                                                    notFoundContent={
                                                        <div className="text-center p-4">
                                                            {loading11 ? (
                                                                <span>
                                                                    <LoadingOutlined />
                                                                    Loading...
                                                                </span>
                                                            ) : (
                                                                <span>No template found</span>
                                                            )}
                                                        </div>
                                                    } />
                                            </Form.Item>
                                        </div>
                                        <Form.Item className={`col-md-12 px-2 desc-form`} label="Description" name="description"
                                            normalize={(value) =>
                                                value ? value.charAt(0).toUpperCase() + value.slice(1) : ''
                                            }>
                                            <TextArea rows={2} disabled={isPastDate} />
                                        </Form.Item>
                                        <Form.List
                                            name="slots"
                                            initialValue={[
                                                {
                                                    slotID: 0,
                                                    slotName: "",
                                                    startTime: null,
                                                    endTime: null,
                                                    capacity: null,
                                                    associateCondition: '',
                                                    specialization: null,
                                                    status: '',

                                                }
                                            ]}
                                        >
                                            {(fields, { add: addSection, remove: removeSection }, index: any) => (
                                                <div className="px-2 pb-3">
                                                    <div className='row mx-0 mb-2 justify-content-between page-header'>
                                                        <h6 className='col my-auto fw-bold ps-0 text-dark'>Slot Details</h6>
                                                        <div className='text-end col-md-8'>
                                                            <Tooltip title={!duration ? "Please select duration first" : ""}>
                                                                <Button
                                                                    type="primary"
                                                                    size="small"
                                                                    className='ms-2'
                                                                    onClick={() => addSection()}
                                                                // disabled={!canAddSection()} // Disable if any section's total percentage is not 100
                                                                >
                                                                    Add Slot
                                                                </Button>
                                                            </Tooltip>
                                                        </div>

                                                    </div>
                                                    <Table
                                                        rowKey="key"
                                                        columns={[
                                                            {
                                                                title: 'Slot Name',
                                                                dataIndex: 'slotName',
                                                                width: '10%',
                                                                render: (_: any, record: any, index: any) => (
                                                                    <Form.Item
                                                                        className="mb-0"
                                                                        name={[index, 'slotName']}
                                                                        rules={[
                                                                            { required: true, message: 'This field is required' },
                                                                            ({ getFieldValue }) => ({
                                                                                validator(_, value) {
                                                                                    const allSections = getFieldValue('sections') || [];
                                                                                    const duplicates = allSections.filter(
                                                                                        (item: any) =>
                                                                                            item.sectionName !== '' &&
                                                                                            item.sectionName?.toLowerCase() === value?.toLowerCase()
                                                                                    );
                                                                                    if (duplicates.length > 1) {
                                                                                        return Promise.reject('Duplicate section name');
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            }),
                                                                        ]}
                                                                    >
                                                                        <Input />
                                                                    </Form.Item>
                                                                ),
                                                            },
                                                            {
                                                                title: 'Start Time',
                                                                dataIndex: 'startTime',
                                                                width: '10%',
                                                                render: (_: any, record: any, index: any) => {
                                                                    return (
                                                                        <Form.Item
                                                                            className="mb-0"
                                                                            name={[index, 'startTime']}
                                                                            rules={[{ message: 'This field is required', required: true }]}>
                                                                            <TimePicker
                                                                                onChange={(time) => handleStartTimeChange(time, index)}
                                                                                format="hh:mm a"
                                                                                className="w-100"
                                                                                disabled={isPastDate || !duration}
                                                                                placeholder={!duration ? "Select duration first" : "Select time"}
                                                                                disabledTime={() => {
                                                                                    if (!slots || slots.length === 0 || index === 0) return {};

                                                                                    const prevStart = slots[index - 1]?.startTime;
                                                                                    if (!prevStart) return {};

                                                                                    const prevHour = dayjs(prevStart).hour();
                                                                                    const prevMinute = dayjs(prevStart).minute();
                                                                                    const isPM = prevHour >= 12;
                                                                                    let prevHour12 = prevHour % 12;
                                                                                    if (prevHour12 === 0) prevHour12 = 12;

                                                                                    return {
                                                                                        disabledHours: () =>
                                                                                            Array.from({ length: prevHour12 - 1 }, (_, i) => i + 1),
                                                                                        disabledMinutes: (hour) => {
                                                                                            if (hour === prevHour12) {
                                                                                                return Array.from({ length: prevMinute + 1 }, (_, i) => i);
                                                                                            }
                                                                                            return [];
                                                                                        },
                                                                                    };
                                                                                }}
                                                                            />
                                                                        </Form.Item>
                                                                    )
                                                                }
                                                            },
                                                            {
                                                                title: 'End Time',
                                                                dataIndex: 'endTime',
                                                                width: '10%',
                                                                render: (_: any, record: any, index: any) => {
                                                                    return (
                                                                        <Form.Item
                                                                            className="mb-0"
                                                                            name={[index, 'endTime']}
                                                                            rules={[{ message: 'This field is required', required: true }]}>
                                                                            <TimePicker format="hh:mm a" className="w-100" disabled placeholder='Select start time' />
                                                                        </Form.Item>

                                                                    )
                                                                }
                                                            },
                                                            {
                                                                title: 'Capacity',
                                                                dataIndex: 'capacity',
                                                                width: '8%',
                                                                render: (_: any, record: any, index: any) => (
                                                                    <Form.Item
                                                                        className="mb-0"
                                                                        name={[index, 'capacity']}
                                                                        rules={[{
                                                                            validator: (_, value) =>
                                                                                value ? Promise.resolve() : Promise.reject("This field is required"),
                                                                        },]}
                                                                    >
                                                                        <InputNumber
                                                                            className="w-100"
                                                                            min={0}
                                                                        // disabled={!totalMarksValue}
                                                                        // onChange={() => handleSectionMarksChange(index)}
                                                                        />
                                                                    </Form.Item>
                                                                ),
                                                            },
                                                            {
                                                                title: 'Associate Condition',
                                                                dataIndex: 'associateCondition',
                                                                width: '10%',
                                                                render: (_: any, record: any, index: any) => {
                                                                    return (
                                                                        <Form.Item
                                                                            className="mb-0"
                                                                            name={[index, 'associateCondition']}
                                                                            rules={[{ message: 'This field is required', required: true }]}>
                                                                            {/* <Select
                                                                                options={getFilteredAssociateConditionOptions()}
                                                                                // onChange={handleFormChange}
                                                                                className='pt-1'
                                                                            /> */}
                                                                            <Select className="w-100" options={options}
                                                                                onChange={(value) => handleAssociateConditionChange(value, index)} />
                                                                        </Form.Item>
                                                                    )
                                                                }
                                                            },
                                                            {
                                                                title: 'Department/Course/Gender', // Changed title to be more generic
                                                                dataIndex: 'specialization',
                                                                render: (_: any, record: any, index: any) => {
                                                                    return (
                                                                        <Form.Item
                                                                            noStyle
                                                                            shouldUpdate={(prevValues, currentValues) => {
                                                                                const prevCondition = prevValues?.slots?.[index]?.associateCondition;
                                                                                const currCondition = currentValues?.slots?.[index]?.associateCondition;
                                                                                return prevCondition !== currCondition;
                                                                            }}
                                                                        >
                                                                            {({ getFieldValue }) => {
                                                                                const slots = getFieldValue('slots') || [];
                                                                                const condition = slots[index]?.associateCondition;
                                                                                const isAllSelected = condition === 'all';
                                                                                const isGenderSelected = condition === 'gender';

                                                                                // Get dynamic options based on condition
                                                                                const dynamicOptions = getSpecializationOptions(condition);
                                                                                const placeholderText = isAllSelected
                                                                                    ? "All selected"
                                                                                    : `Select ${getSpecializationLabel(condition)}`;
                                                                                const handleSpecializationChange = (values: any) => {
                                                                                    // Get labels for selected values
                                                                                    const labels = values && values.length > 0
                                                                                        ? values.map((val: any) => {
                                                                                            const option = dynamicOptions.find((opt: any) => opt.value === val);
                                                                                            return option?.label || val;
                                                                                        })
                                                                                        : null;

                                                                                    // Update slots state directly
                                                                                    setSlots((prevSlots: any) => {
                                                                                        const updatedSlots = [...prevSlots];
                                                                                        updatedSlots[index] = {
                                                                                            ...updatedSlots[index],
                                                                                            ConditionIDs: values ? values.toString() : null,
                                                                                            conditionName: labels ? labels.toString() : null,
                                                                                        };
                                                                                        return updatedSlots;
                                                                                    });
                                                                                    const currentSlots = form.getFieldValue('slots') || [];
                                                                                    const updatedFormSlots = [...currentSlots];
                                                                                    updatedFormSlots[index] = {
                                                                                        ...updatedFormSlots[index],
                                                                                        conditionName: labels ? labels.toString() : null,
                                                                                    };
                                                                                    form.setFieldsValue({ slots: updatedFormSlots });
                                                                                    // Also trigger section update
                                                                                    handleSlotFieldChange(index, 'specialization', values);
                                                                                };
                                                                                return (
                                                                                    <>
                                                                                        <Form.Item
                                                                                            className="mb-0"
                                                                                            name={[index, 'specialization']}
                                                                                            rules={[
                                                                                                {
                                                                                                    message: 'This field is required',
                                                                                                    required: !isAllSelected
                                                                                                }
                                                                                            ]}
                                                                                        >
                                                                                            <Select
                                                                                                className="w-100"
                                                                                                options={dynamicOptions}
                                                                                                disabled={isAllSelected || !condition}
                                                                                                placeholder={placeholderText}
                                                                                                mode={"multiple"} // Single select for gender, multiple for others
                                                                                                showSearch
                                                                                                filterOption={(input: any, option: any) => {
                                                                                                    return option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                                                                }}
                                                                                                onChange={handleSpecializationChange}
                                                                                            />
                                                                                        </Form.Item>
                                                                                        <Form.Item name={[index, 'conditionName']} hidden>
                                                                                            <Input />
                                                                                        </Form.Item>
                                                                                    </>
                                                                                );
                                                                            }}
                                                                        </Form.Item>
                                                                    )
                                                                }
                                                            },
                                                            {
                                                                title: 'Status',
                                                                dataIndex: 'status',
                                                                // width: '20%',
                                                                render: (_: any, record: any, index: any) => {
                                                                    // Get the current associate condition value for this row

                                                                    return (
                                                                        <Form.Item
                                                                            className="mb-0"
                                                                            name={[index, 'status']}
                                                                            rules={[{ message: 'This field is required', required: true }]}>
                                                                            <Select className="w-100" options={statusOptions}
                                                                                disabled={isPastDate} />
                                                                        </Form.Item>
                                                                    )
                                                                }
                                                            },
                                                            {
                                                                title: 'Actions',
                                                                dataIndex: 'actions',
                                                                align: 'center',
                                                                width: '5%',
                                                                render: (_: any, __: any, subIndex: any) => (
                                                                    <div className="my-auto delete-icon d-flex text-center align-items-center justify-content-center">
                                                                        {subIndex == 0 ? <Tooltip title="Atlease one slot should be added"><DeleteFilled className='text-gray del-icon' /></Tooltip> :
                                                                            <Popconfirm
                                                                                title="Delete Slot" description="Are you sure to delete this slot?" onConfirm={() => removeSection(subIndex)} okText="Yes" cancelText="No">
                                                                                <DeleteFilled className="text-danger pointer del-icon" />
                                                                            </Popconfirm>}
                                                                    </div>
                                                                ),
                                                            },
                                                        ]}
                                                        dataSource={fields}
                                                        pagination={false}
                                                        bordered
                                                        size="small"
                                                        className="section-table"
                                                    />
                                                </div>)}
                                        </Form.List>
                                    </div>
                                </div>
                            </Form> : <CreateSlot examUniqueId = {location.state.examData.examUniqueId}
                                totalMark={form.getFieldValue("totalMark")}
                                isPastDate={isPastDate}
                                currentStep={currentStep}
                                slots={slots} duration={duration} tempOptions={tempOpt}
                                college={form.getFieldValue("college")} examName={form.getFieldValue('examName')} />}
                    </div>
                    <div className='py-2 px-0 row m-0 page-footer-btns'>
                        <div className='col ps-0'>
                            {currentStep == 0 ? "" :
                                <Button type="default">Previous</Button>}
                        </div>
                        {currentStep == 1 ? "" :
                            <div className='col pe-0 justify-content-end d-flex ms-auto'>
                                <Button type="primary" onClick={submitForm} loading={loading1}>Save & Next</Button>
                            </div>}
                    </div>
                </div>
            </Spin>
        </div>
    )
}

export default CreateExam;
